import { styled } from '@mui/material/styles';

// Temporary module due to SSR issues
// import muiPhoneInputSsr from 'mui-phone-input-ssr';
import muiPhoneInputSsr from 'material-ui-phone-number';

export const MuiPhoneNumberStyled = styled(muiPhoneInputSsr)`
  width: 250px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
